// @flow

import type { couponType } from '../../types';
import { hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';

export const getSingle = (
  code: string,
): Promise<wrappedApiResponseType<couponType>> =>
  hpfetch(`coupons/favorites/${code}/`);

export const getMany = (
  limit: number = 100,
  offset: number = 0,
): djangoModelApiResponse<couponType> =>
  hpfetch(`coupons/favorites/?limit=${limit}&offset=${offset}`);

export const addToFavorites = (code: string): Promise<any> =>
  hpfetch(`coupons/${code}/favorite/`, {
    method: 'POST',
  });

export const removeFromFavorites = (code: string): Promise<any> =>
  hpfetch(`coupons/favorites/${code}/`, {
    method: 'DELETE',
  });
